var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3872 9.00829C12.2782 8.90207 12.1576 8.81242 12.0323 8.73445L3.624 0.595329C2.80336 -0.198318 1.47337 -0.198694 0.652347 0.595706C-0.168291 1.38973 -0.168291 2.67757 0.652347 3.47235L7.89412 10.4818L0.61577 17.5282C-0.205257 18.3219 -0.205257 19.6101 0.61577 20.4049C1.02628 20.8015 1.56365 21 2.10101 21C2.63838 21 3.17691 20.8015 3.58626 20.4041L12.0323 12.2292C12.1576 12.1512 12.2779 12.062 12.3872 11.9554C12.8074 11.5486 13.009 11.0144 12.9997 10.4818C13.0094 9.94884 12.8074 9.41396 12.3872 9.00829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.697152d0d1e22884ff40d18ce7e0b23c.svg";
export { ForwardRef as ReactComponent };